export const emailValidationPattern = {
    regexString: '^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]{2,20}'
};
